import React from 'react';
import { View, Text, Image } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";

import styles from './style';

const HeaderDefault = ({ title }) => {
    const navigation = useNavigation();

    return (
        <View style={styles.container}>
            <View style={styles.contentLeft}>
                <MaterialIcons
                    name="keyboard-arrow-left"
                    size={30}
                    color="#fff"
                    style={styles.iconsHeader}
                    onPress={() => navigation.goBack()}
                />
            </View>
            <View style={styles.contentCenter}>
                <Text style={styles.title}>{title}</Text>
            </View>
            <View style={styles.contentRight}></View>
        </View>
    );
}

export default HeaderDefault;